const FETCH_LUNAR_SIGNS_REQUEST = "FETCH_LUNAR_SIGNS_REQUEST";
const FETCH_LUNAR_SIGNS_SUCCESS = "FETCH_LUNAR_SIGNS_SUCCESS";
const FETCH_LUNAR_SIGNS_FAILURE = "FETCH_LUNAR_SIGNS_FAILURE";

export default {
  FETCH_LUNAR_SIGNS_REQUEST,
  FETCH_LUNAR_SIGNS_SUCCESS,
  FETCH_LUNAR_SIGNS_FAILURE,
};
